import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.044,18.924a.375.375,0,1,1,0,.531.377.377,0,0,1,0-.531"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M19.086,17.709l3.688-3.687a1.624,1.624,0,1,0-2.3-2.3L16.79,15.413a4.06,4.06,0,1,0,2.3,2.3Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 6,
			cy: 3.75,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M11.032,12A5.25,5.25,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5L8.775,18"
		})
	]
});
const ForwardRef = forwardRef(SvgUsers);
export default ForwardRef;
